import { useQuery, QueryFunction } from 'react-query';
import { getSectionsByTemplateId, FormSectionWithQuestions, FormSection } from '../../../../services/apiSLTP/qhse/forms/formSections';

type UseSectionsQueryOptions = { templateId: string };

const fetchSections: QueryFunction<FormSectionWithQuestions[] | FormSection[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseSectionsQueryOptions];
    return await getSectionsByTemplateId(options.templateId);
};

export const useFormSectionsQuery = (options: UseSectionsQueryOptions) => {
    return useQuery(['formSections', options], fetchSections);
};
